import Cookie from 'js-cookie';

import { determineDeviceByClientSize, LAYOUTS } from '@ott/layout-context';

export const commonKmDataGetters = {
  referrer: () => Cookie.get('referrer'),
  referrer_mrk: () => Cookie.get('referrer_mrk'),
  abst: () => Cookie.get('abst'),
  vid_cookie: () => Cookie.get('vid'),
  isMobile: () => determineDeviceByClientSize(window.innerWidth) === LAYOUTS.MOBILE,
};
